module.exports = __webpack_public_path__ + "static/media/logo_gray.a09efc61.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo_gray.svg
// module id = 1506
// module chunks = 0